// extracted by mini-css-extract-plugin
export default {"control":"EditEmployee_control__nOlpq","labell":"EditEmployee_labell__Xx6IG","lastcontrol":"EditEmployee_lastcontrol__AJG1t"};